/* VOLUFILINE — FAQ (2 columns): smooth open/close + one item open at a time.
   Progressive enhancement over native <details>; without JS the accordion still works.
   Reduced motion: toggles instantly. Tracking stays in vf-landing.js (details[data-vf-faq] toggle). */
(function () {
  if (window.__vfFaq2) return;
  window.__vfFaq2 = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  function still() { return reduce && reduce.matches; }

  function done(a, fn) {
    var t;
    function end(e) { if (e && e.target !== a) return; clearTimeout(t); a.removeEventListener('transitionend', end); fn(); }
    a.addEventListener('transitionend', end);
    t = setTimeout(end, 450);
  }

  function close(det) {
    if (!det.open || det.classList.contains('is-closing')) return;
    var a = det.querySelector('.vf-faq2__a');
    if (still() || !a) { det.open = false; return; }
    a.style.height = a.offsetHeight + 'px';
    a.classList.add('is-anim');
    det.classList.add('is-closing');
    a.offsetHeight; // reflow
    a.style.height = '0px';
    done(a, function () {
      det.open = false;
      det.classList.remove('is-closing');
      a.classList.remove('is-anim');
      a.style.height = '';
    });
  }

  function open(det) {
    var a = det.querySelector('.vf-faq2__a');
    det.open = true;
    if (still() || !a) return;
    var h = a.scrollHeight;
    a.style.height = '0px';
    a.classList.add('is-anim');
    a.offsetHeight;
    a.style.height = h + 'px';
    done(a, function () { a.classList.remove('is-anim'); a.style.height = ''; });
  }

  function init(list) {
    if (list.__vfFaq2) return;
    list.__vfFaq2 = true;
    list.addEventListener('click', function (e) {
      var sum = e.target.closest('summary.vf-faq2__q');
      if (!sum || !list.contains(sum)) return;
      var det = sum.parentNode;
      e.preventDefault();
      if (det.open && !det.classList.contains('is-closing')) { close(det); return; }
      list.querySelectorAll('details.vf-faq2__item[open]').forEach(function (o) { if (o !== det) close(o); });
      open(det);
    });
  }

  function boot() { document.querySelectorAll('[data-vf-faq2]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
